import { Component, OnInit } from '@angular/core';
import { EditPhotoComponent } from '../edit-photo/edit-photo.component';
import { AppService } from '../../../app.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-edit-photo-test',
    templateUrl: './edit-photo-test.component.html',
    styleUrls: ['./edit-photo-test.component.scss']
})
export class EditPhotoTestComponent implements OnInit {
    photo: string;

    constructor(public editPhotoComponent: MatDialog,
                private _appService: AppService,
                private _sanitizer: DomSanitizer) { }

    ngOnInit() {
        this._appService.getPhoto().subscribe((r: any) => {
            this.photo = r
        });
    }

    openEditPhoto() {
        let editPhotoModalRef = this.editPhotoComponent.open(EditPhotoComponent, {
            width: '1024px',
            height: '768px',
            data: { photo: this.photo }
        });
        editPhotoModalRef.afterClosed().subscribe(res => {
            if (res != null) {
                this.photo = res.photo;
            }
        });
    }
}
